// extracted by mini-css-extract-plugin
export default {"screenModeButton":"style_screenModeButton__VuDBY"};